export enum PayrollFileValidityStatusEnum {
  OK = "OK",
}
